/* TRIO – Refonte 2026 */
(function () {
  'use strict';
  if (window.__trioLoaded) return;
  window.__trioLoaded = true;

  var money = function (cents, currency) {
    try { return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: currency || 'EUR' }); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  };

  function initAnnouncement(root) {
    root.querySelectorAll('[data-tr-ann]').forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      var items = bar.querySelectorAll('.tr-ann__item');
      if (!items.length) return;
      var i = 0;
      items[0].classList.add('is-active');
      if (items.length < 2) return;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4000);
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-tr-tabs]').forEach(function (tabs) {
      var btns = tabs.querySelectorAll('[data-tr-tab]');
      var panels = tabs.querySelectorAll('[data-tr-panel]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-selected', b === btn); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.trPanel === btn.dataset.trTab); });
        });
      });
    });
  }

  function initFilters(root) {
    root.querySelectorAll('[data-tr-filter-group]').forEach(function (group) {
      var chips = group.querySelectorAll('[data-tr-filter]');
      var scope = document.getElementById(group.dataset.trFilterGroup);
      if (!scope) return;
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
          var val = chip.dataset.trFilter;
          scope.querySelectorAll('[data-tr-item]').forEach(function (item) {
            var keys = (item.dataset.trKeys || '').split('|');
            item.style.display = (val === '*' || keys.indexOf(val) !== -1) ? '' : 'none';
          });
          if (val !== '*') scope.querySelectorAll('.tr-review.is-hidden').forEach(function (r) { r.classList.remove('is-hidden'); });
          var more = scope.parentElement.querySelector('[data-tr-more]');
          if (more) more.style.display = (val === '*' && scope.querySelector('.tr-review.is-hidden')) ? '' : 'none';
        });
      });
    });
    root.querySelectorAll('[data-tr-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var scope = document.getElementById(btn.dataset.trMore);
        var step = parseInt(btn.dataset.step || '9', 10);
        var hidden = scope.querySelectorAll('.tr-review.is-hidden');
        for (var i = 0; i < hidden.length && i < step; i++) hidden[i].classList.remove('is-hidden');
        if (!scope.querySelector('.tr-review.is-hidden')) btn.style.display = 'none';
      });
    });
  }

  function initFaqSearch(root) {
    root.querySelectorAll('[data-tr-faq-search]').forEach(function (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var found = 0;
        document.querySelectorAll('.tr-faq__item').forEach(function (item) {
          var match = !q || item.textContent.toLowerCase().indexOf(q) !== -1;
          item.classList.toggle('is-hidden', !match);
          if (match) found++;
          if (q && match) item.setAttribute('open', '');
        });
        document.querySelectorAll('.tr-faq__cat').forEach(function (cat) {
          var next = cat.nextElementSibling, any = false;
          while (next && next.classList.contains('tr-faq__item')) {
            if (!next.classList.contains('is-hidden')) any = true;
            next = next.nextElementSibling;
          }
          cat.style.display = any ? '' : 'none';
        });
        document.querySelectorAll('.tr-faq__none').forEach(function (n) { n.style.display = found ? 'none' : 'block'; });
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var faq = document.querySelector('.tr-faq');
          if (faq) faq.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function initProduct(root) {
    root.querySelectorAll('[data-tr-product]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var json = el.querySelector('[data-tr-product-json]');
      if (!json) return;
      var product = JSON.parse(json.textContent);
      var currency = el.dataset.currency;
      var idInput = el.querySelector('[name="id"]');
      var priceNow = el.querySelector('[data-tr-price]');
      var priceWas = el.querySelector('[data-tr-compare]');
      var badge = el.querySelector('[data-tr-badge]');
      var colorLabel = el.querySelector('[data-tr-color]');
      var stock = el.querySelector('[data-tr-stock]');
      var stockText = el.querySelector('[data-tr-stock-text]');
      var addBtns = el.querySelectorAll('[data-tr-add]');
      var mainImg = el.querySelector('[data-tr-main-img]');
      var thumbs = el.querySelectorAll('[data-tr-thumb]');

      function showMedia(thumb) {
        if (!thumb || !mainImg) return;
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        mainImg.srcset = thumb.dataset.srcset || '';
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt || '';
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t); }); });

      function setVariant(v) {
        if (!v) return;
        idInput.value = v.id;
        if (priceNow) priceNow.textContent = money(v.price, currency);
        var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
        if (priceWas) { priceWas.textContent = hasCompare ? money(v.compare_at_price, currency) : ''; priceWas.style.display = hasCompare ? '' : 'none'; }
        if (badge) {
          if (hasCompare) { badge.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; badge.style.display = ''; }
          else badge.style.display = 'none';
        }
        if (colorLabel) colorLabel.textContent = v.option1;
        if (stock) {
          stock.classList.toggle('is-out', !v.available);
          if (stockText) stockText.innerHTML = v.available ? stockText.dataset.in : stockText.dataset.out;
        }
        addBtns.forEach(function (b) { b.disabled = !v.available; });
        if (v.featured_media) {
          var t = el.querySelector('[data-tr-thumb][data-media-id="' + v.featured_media.id + '"]');
          if (t) showMedia(t);
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      el.querySelectorAll('[data-tr-swatch]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          el.querySelectorAll('[data-tr-swatch]').forEach(function (s) { s.classList.toggle('is-active', s === sw); s.setAttribute('aria-pressed', s === sw); });
          setVariant(product.variants.find(function (x) { return String(x.id) === sw.dataset.trSwatch; }));
        });
      });

      var sel = el.querySelector('[data-tr-variant-select]');
      if (sel) sel.addEventListener('change', function () {
        setVariant(product.variants.find(function (x) { return String(x.id) === sel.value; }));
      });

      var qty = el.querySelector('[data-tr-qty]');
      if (qty) {
        var input = qty.querySelector('input');
        qty.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            input.value = Math.max(1, parseInt(input.value || '1', 10) + parseInt(b.dataset.step, 10));
          });
        });
      }

      var buyNow = el.querySelector('[data-tr-buynow]');
      var addBtn = el.querySelector('[data-tr-add]:not([data-tr-buynow])');
      var form = el.querySelector('form[action*="/cart/add"]');
      function setReturn(val) {
        if (!form) return;
        var ret = form.querySelector('[name="return_to"]');
        if (!ret) { ret = document.createElement('input'); ret.type = 'hidden'; ret.name = 'return_to'; form.appendChild(ret); }
        ret.value = val;
      }
      if (buyNow) buyNow.addEventListener('click', function () { setReturn('/checkout'); });
      if (addBtn) addBtn.addEventListener('click', function () { setReturn('/cart'); });
    });
  }

  function initReveal(root) {
    var items = root.querySelectorAll('.tr-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { items.forEach(function (i) { i.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (i) { io.observe(i); });
  }

  function init(root) {
    root = root || document;
    initAnnouncement(root);
    initTabs(root);
    initFilters(root);
    initFaqSearch(root);
    initProduct(root);
    initReveal(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
